import PhotosFacetOverviewModal from './PhotosFacetOverviewModal';

export default PhotosFacetOverviewModal;
